module.exports = __webpack_public_path__ + "assets/roboto-light.e835bad984d2a3b8286c5dbce1b28703cab3221c86fcbfd0b04ce49e4826ea49.woff";